import React from "react";
import classnames from "classnames";
import classNames from "classnames/bind";
import Tooltip from "./../../atoms/tooltip/index.jsx";

import styles from "./styles.scss";

let cx = classNames.bind(styles);

export default class FormWizardStep extends React.Component {
  render() {
    var stepName = this.props.name;
    var state = this.props.state;

    let className = cx({
      formWizardStep: true,
      [`${state}`]: true,
    });

    return (
      <div className={classnames(className)} onClick={this.props.onClick}>
        <div className="stepPoint">
          <div className="stepNameTooltip">
            <Tooltip position="center">{stepName}</Tooltip>
          </div>
        </div>
      </div>
    );
  }
}
